/* FG Klarna badge sync — shared helper for snippets/fg-klarna-badge.liquid instances.
   Updates the real Klarna OSM placement's purchase amount, asks the OSM library to
   refresh, and toggles the static fallback if Klarna never renders. */
if (!window.__fgKlarnaBadgeInit) {
  window.__fgKlarnaBadgeInit = true;

  window.fgKlarnaSync = function (wrap, cents) {
    if (!wrap) return;
    var placement = wrap.querySelector('[data-match-klarna-placement]');
    var fallback = wrap.querySelector('[data-match-klarna-fallback]');
    var monthlyEl = wrap.querySelector('[data-match-klarna-monthly]');

    if (typeof cents === 'number' && !isNaN(cents)) {
      if (placement) placement.setAttribute('data-purchase-amount', Math.round(cents));
      /* Fallback quote = price / 12 (no interest — only shown when Klarna itself is unavailable) */
      if (monthlyEl) monthlyEl.textContent = '$' + (Math.round(cents / 12) / 100).toFixed(2).replace(/\.00$/, '');
    }

    wrap.hidden = false;

    /* Ask the OSM library to (re)process placements — classic lib + new web SDK APIs. */
    try {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    } catch (e) {}
    try {
      if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        window.Klarna.OnsiteMessaging.refresh();
      }
    } catch (e) {}

    /* Show whichever rendered — never both. Only the most recent sync's poll loop may
       act (rapid variant changes spawn overlapping loops), and polling continues after
       the fallback is shown so a late Klarna render replaces it instead of stacking. */
    var token = (wrap.__fgKlarnaSyncToken || 0) + 1;
    wrap.__fgKlarnaSyncToken = token;
    var attempts = 0;
    (function check() {
      if (wrap.__fgKlarnaSyncToken !== token) return;
      var rendered = placement && (
        (placement.shadowRoot && placement.shadowRoot.childElementCount > 0) ||
        placement.childElementCount > 0
      );
      if (rendered) {
        if (fallback) fallback.hidden = true;
        return;
      }
      if (attempts >= 10 && fallback) fallback.hidden = false;
      if (attempts++ < 100) setTimeout(check, 300);
    })();
  };

  /* Auto-run once for badges rendered visible with a server-side amount. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-match-klarna]:not([hidden])').forEach(function (wrap) {
      window.fgKlarnaSync(wrap);
    });
  });
}
